import { useState, useEffect } from 'react';

interface Props {
  id?: string;
  classname?: string;
  disabled?: boolean;
  label: string;
  errors?: any;
  setValue?: any;
  initialState?: string;
  onChange?: any;
  register?: any;
  options?: any;
  placeholder?: string;
  defaultValue?: string;
}

export const CustomFloatingSelect: React.FC<Props> = ({
  id,
  classname,
  disabled,
  label,
  errors,
  setValue,
  initialState,
  register,
  onChange,
  options,
  placeholder,
  defaultValue,
}) => {
  const [selectedState, setSelectedState] = useState('');

  useEffect(() => {
    setSelectedState(initialState ?? 'B-ADD');
  }, [initialState]);

  useEffect(() => {
    setValue(label, selectedState);
  }, [setValue, label, selectedState]);

  const handleSelectState = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSelectedState(selectedValue);
    setValue(label, selectedValue);
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <section className="relative w-full">
      <select
        id={id}
        defaultValue={defaultValue}
        className={
          'gbmask peer block appearance-none rounded-lg border bg-transparent p-4 text-base text-black ' +
          (errors[label] ? ' border-2 border-scarletRed text-scarletRed ' : ' border-foggyGray text-black ') +
          classname
        }
        value={selectedState}
        placeholder={placeholder}
        onChange={handleSelectState}
        disabled={disabled}
        {...register(label, { onChange: handleSelectState })}
      >
        <option value="" selected hidden>
          <p className="text-red-500">{placeholder}</p>
        </option>
        {options}
      </select>

      {selectedState ? (
        <label
          htmlFor={id}
          className={
            'absolute start-1 top-2 ml-1 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-base duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4 ' +
            (errors[label]?.message && 'text-scarletRed')
          }
        >
          {placeholder}
        </label>
      ) : null}

      {errors[label] && <p className="absolute mt-2 text-sm text-scarletRed">{errors[label]?.message}</p>}
    </section>
  );
};
